// removed by extract-text-webpack-plugin
module.exports = {"resultColor":"#b66e19","resultColorAlpha":"rgba(182, 110, 25, 0.5)","noResultColor":"#555","highlightColor":"#fc9e23","selectedColor":"#f0ad4e","brushSelectionColor":"#e75649"};


//////////////////
// WEBPACK FOOTER
// ./src/css/filter.css
// module id = 925
// module chunks = 0